import { Observable } from "@dooboostore/core";
var EventUtils;
((EventUtils2) => {
  EventUtils2.htmlElementEventObservable = (element, type, options) => {
    return new Observable((subscriber) => {
      const handler = (event) => subscriber.next(event);
      element.addEventListener(type, handler, options);
      return () => {
        element.removeEventListener(type, handler, options);
      };
    });
  };
})(EventUtils || (EventUtils = {}));
export {
  EventUtils
};
//# sourceMappingURL=EventUtils.js.map
